import { render } from "./admin_dashboard.vue?vue&type=template&id=32136b58&scoped=true"
import script from "./admin_dashboard.vue?vue&type=script&lang=js"
export * from "./admin_dashboard.vue?vue&type=script&lang=js"

import "./admin_dashboard.vue?vue&type=style&index=0&id=32136b58&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32136b58"]])

export default __exports__